export const Types = {
  TOGGLE_SECTION_OPEN: 'TOGGLE_SECTION_OPEN',
  REGISTER_SECTION: 'REGISTER_SECTION',
  UNREGISTER_SECTION: 'UNREGISTER_SECTION',
  CLEAR_SECTION_SAVE_ERRORS: 'CLEAR_SECTION_SAVE_ERRORS',
};

export const toggleSectionOpen = (sectionGroup, sectionKey, scrollTo) => ({
  type: Types.TOGGLE_SECTION_OPEN,
  sectionGroup: sectionGroup,
  sectionKey: sectionKey,
  scrollTo: scrollTo
});

export const registerSection = (sectionGroup, sectionKey) => ({
  type: Types.REGISTER_SECTION,
  sectionGroup: sectionGroup,
  sectionKey: sectionKey
});

export const unregisterSection = (sectionGroup, sectionKey) => ({
  type: Types.UNREGISTER_SECTION,
  sectionGroup: sectionGroup,
  sectionKey: sectionKey
});

export const clearSectionSaveErrors = sectionKey => ({
  type: Types.CLEAR_SECTION_SAVE_ERRORS,
  sectionKey
});



// WEBPACK FOOTER //
// ./public/utils/sectionManagement/actions.js